/**
 * The password floor, mirrored from the server's own policy
 * (src/domain/password-policy.ts) so a form can say the rule BEFORE somebody
 * is refused by it. The server is still what enforces it; this only decides
 * what the screen promises, and the two are checked against each other by
 * tests/passwordpolicy.test.ts.
 */
export const MIN_PASSWORD_LENGTH = 12;
